import React from 'react';
import moment from 'moment';

import classnames from 'classnames/bind';
import getOr from '~/util/getOr';
import css from './Card.scss';

const cssContext = classnames.bind(css);

const formatPlayers = (players, rounds, eventStatus, cut) =>
  players.map(elem => {
    const player = getOr(elem, 'node', {});

    if (cut ? player.status === 'SWINGING' : player.status !== 'SWINGING') return null;

    if (eventStatus === 'FINAL' || eventStatus === 'IN_PROGRESS') {
      let playerRank = '';
      if (player.status === 'SWINGING') {
        playerRank = `${player.rankTied ? 'T' : ''}${player.rank ? player.rank : '-'}`;
      } else {
        playerRank = player.status === 'MISSED_CUT' ? 'MC' : 'WD';
      }

      return (
        <div className={css.detailRow} key={player.player.id}>
          <span className={css.vertCenter}>
            <span className={css.rank}>{playerRank}</span>
            <img
              className={css.flagContainer}
              src={player.player.country.flags[0].url}
              alt={`Flag of ${player.player.country.name}`}
            />
            {player.player.firstInitialAndLastName}
          </span>
          <span className={css.vertCenter}>
            {eventStatus === 'FINAL' &&
              rounds.map((round, i) => (
                <span className={css.cell} key={round.id}>
                  {getOr(
                    player,
                    `playerRoundRecords.edges.${i}.node.strokes`,
                    String.fromCharCode(183)
                  )}
                </span>
              ))}
            <span className={css.cell}>{player.score}</span>
          </span>
        </div>
      );
    }
    return (
      <div className={css.detailRow} key={player.player.id}>
        <span className={css.vertCenter}>
          <img
            className={css.flagContainer}
            src={player.player.country.flags[0].url}
            alt={`Flag of ${player.player.country.name}`}
          />
          {player.player.firstInitialAndLastName}
        </span>
      </div>
    );
  });

interface Props {
  data: {
    node: any;
  };
  event: any;
  eventStatus: string;
}

interface State {
  selectedRound: number;
}

class GolfPlayers extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      selectedRound: 0,
    };

    this.renderMatches = this.renderMatches.bind(this);
    this.renderPlayers = this.renderPlayers.bind(this);
    this.toggleMatches = this.toggleMatches.bind(this);
  }

  toggleMatches = function(i) {
    document.querySelector(`.${css.dropdown} > .${css.clickable}`).classList.toggle(css.open);
    document.querySelector(`.${css.dropdownContainer}`).classList.toggle(css.open);
    this.setState({
      selectedRound: i,
    });
  };

  showDropwdown = function(e) {
    e.currentTarget.classList.toggle(css.open);
    document.querySelector(`.${css.dropdownContainer}`).classList.toggle(css.open);
  };

  renderMatches = data => {
    const { event } = this.props;
    const rounds = getOr(data, 'golfEvents.edges.0.node.rounds.edges', []);
    const roster = getOr(event, 'rosters.edges', []);
    const matches = getOr(rounds[this.state.selectedRound], 'node.matches.edges', []);

    const getMatchStatus = (complete, teeTime) => {
      const teeTimeString = teeTime ? moment(teeTime).format('h:mm A') : '';
      return complete ? 'Final' : teeTimeString;
    };
    return (
      <div>
        {event.status === 'SCHEDULED' &&
          roster.length > 0 && (
            <div>
              {roster.map(elem => {
                const teamName = getOr(elem, 'node.teamName', '');
                const players = getOr(elem, 'node.players.edges', []);

                return (
                  <div key={elem.id}>
                    <div className={css.detailTitle}>
                      <span>{`TEAM ${teamName.toUpperCase()}`}</span>
                    </div>
                    {players.map(p => {
                      const player = getOr(p, 'node', {});
                      return (
                        <div className={css.detailRow} key={player.id}>
                          <span className={css.vertCenter}>
                            <img
                              className={css.flagContainer}
                              src={player.country.flags[0].url}
                              alt={`Flag of ${player.country.name}`}
                            />
                            {player.firstInitialAndLastName}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          )}

        <div>
          <div className={css.dropdown}>
            <span className={css.clickable} onClick={e => this.showDropwdown(e)}>
              Round {this.state.selectedRound + 1}
              <span className={css.chevron} />
            </span>

            <div className={css.dropdownContainer}>
              {rounds.map((_, i) => (
                <div
                  className={`col-xs-6 col-sm-3 ${css.dropdownItem}`}
                  onClick={() => this.toggleMatches(i)}
                >
                  Round {i + 1}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={css.matchContainer}>
          {matches.map(elem => {
            const pairings = getOr(elem, 'node.pairings.edges', []);
            const score = getOr(elem, 'node.score');
            const complete = getOr(elem, 'node.complete', false);
            const teeTime = getOr(elem, 'node.teeTime', '');
            const leader = getOr(elem, 'node.leadingPairing.id', '');

            return (
              <div className={css.matches}>
                <span className={css.matchStatus}>{getMatchStatus(complete, teeTime)}</span>

                <div className={css.justify}>
                  <div>
                    {pairings.map(e => {
                      const flag = getOr(e, 'node.country.flags.0.url', '');
                      const country = getOr(e, 'node.country.name', '');
                      const players = getOr(e, 'node.players.edges', []);
                      const pairingId = getOr(e, 'node.id', '');
                      const nameClasses = cssContext(css.vertCenter, {
                        selected: !leader || pairingId === leader || score === 'HALVED',
                      });

                      return (
                        <span className={nameClasses} key={pairingId}>
                          <img
                            className={css.flagContainerLarge}
                            src={flag}
                            alt={`Flag of ${country}`}
                          />
                          {players.map(player => player.node.firstInitialAndLastName).join(', ')}
                        </span>
                      );
                    })}
                  </div>
                  <span className={`${css.vertCenter} ${css.selected}`}>{score}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderPlayers = data => {
    const players = getOr(data, 'node.playerEventRecords.edges', []);
    const rounds = getOr(players, '0.node.playerRoundRecords.edges', []);

    const { event, eventStatus } = this.props;

    const playerHeaderClasses = cssContext(css.detailTitle, {
      justify: event.status !== 'SCHEDULED',
    });

    return (
      <div>
        {players.length ? (
          <div className={css.overflowScroll}>
            <div className={playerHeaderClasses}>
              <span>PLAYERS</span>
              {eventStatus === 'FINAL' && (
                <span className={css.vertCenter} style={{ marginRight: '10px' }}>
                  {rounds.map((_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span className={css.cell} key={`round${i}`}>
                      R{i + 1}
                    </span>
                  ))}
                  <span className={css.cell}>TOT</span>
                </span>
              )}
              {eventStatus === 'IN_PROGRESS' && (
                <span className={css.vertCenter} style={{ marginRight: '10px' }}>
                  <span className={css.cell}>TOT</span>
                </span>
              )}
            </div>
            {formatPlayers(players, rounds, eventStatus, false)}
            {eventStatus === 'FINAL' && (
              <div className={`${css.detailTitle} ${css.justify}`}>
                <span>MISSED CUT/WITHDRAWN</span>
                <span className={css.vertCenter} style={{ marginRight: '10px' }}>
                  {rounds.map((_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span className={css.cell} key={`MCround${i}`}>
                      R{i + 1}
                    </span>
                  ))}
                  <span className={css.cell}>TOT</span>
                </span>
              </div>
            )}
            {formatPlayers(players, rounds, eventStatus, true)}
          </div>
        ) : (
          <div className={css.detailRow}>No Player info available</div>
        )}
      </div>
    );
  };

  render() {
    const { event, data } = this.props;
    return (
      <div>
        {event.eventType === 'STROKE_PLAY' && this.renderPlayers(data)}
        {(event.eventType === 'CUP_PLAY' || event.eventType === 'MATCH_PLAY') &&
          this.renderMatches(data)}
      </div>
    );
  }
}

export default GolfPlayers;
